import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const T = {
  impressum: {
    title: "Impressum",
    note: "Legal notice as required by German law (§ 5 TMG).",
    sections: [
      {
        h: "Angaben gemäß § 5 TMG",
        body: [
          "Ulrike Samson",
          "Englisch in Wandsbek",
          "Tegelweg 113",
          "22159 Hamburg, Deutschland",
        ],
      },
      {
        h: "Kontakt · Contact",
        body: [
          "Telefon: +49 (0) 176 – 482 152 13",
          "E-Mail: Info@Englisch-in-Wandsbek.de",
        ],
      },
      {
        h: "Urheberrecht",
        body: [
          "Alle auf dieser Website von Englisch-in-Wandsbek.de / Ulrike Samson veröffentlichten Beiträge und Abbildungen sind urheberrechtlich geschützt. Jede vom Urheberrechtsgesetz nicht zugelassene Verwertung bedarf vorheriger schriftlicher Zustimmung von Ulrike Samson. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Fotokopien und Downloads von Web-Seiten dürfen nur für den persönlichen, privaten und nicht kommerziellen Gebrauch hergestellt werden.",
        ],
      },
    ],
  },
  datenschutz: {
    title: "Datenschutz",
    note: "Privacy notice as required by German law.",
    sections: [
      {
        h: "1. Haftungsbeschränkung",
        body: [
          "Die Inhalte des Internetauftritts wurden mit größtmöglicher Sorgfalt und nach bestem Gewissen erstellt. Dennoch übernimmt der Anbieter dieser Webseite keine Gewähr für die Aktualität, Vollständigkeit und Richtigkeit der bereitgestellten Seiten und Inhalte.",
          "Als Diensteanbieter ist der Anbieter dieser Webseite gemäß § 7 Abs. 1 TMG für eigene Inhalte und bereitgestellte Informationen auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich; nach den §§ 8 bis 10 TMG jedoch nicht verpflichtet, die übermittelten oder gespeicherten fremden Informationen zu überwachen. Eine Entfernung oder Sperrung dieser Inhalte erfolgt umgehend ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung. Eine Haftung ist erst ab dem Zeitpunkt der Kenntniserlangung möglich.",
        ],
      },
      {
        h: "2. Externe Links",
        body: [
          "Die Webseite enthält sog. „externe Links“ (Verlinkungen) zu anderen Webseiten, auf deren Inhalt der Anbieter der Webseite keinen Einfluss hat. Aus diesem Grund kann der Anbieter für diese Inhalte auch keine Gewähr übernehmen.",
          "Für die Inhalte und Richtigkeit der bereitgestellten Informationen ist der jeweilige Anbieter der verlinkten Webseite verantwortlich. Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße erkennbar. Bei Bekanntwerden einer solchen Rechtsverletzung wird der Link umgehend entfernt.",
        ],
      },
      {
        h: "3. Urheberrecht / Leistungsschutzrecht",
        body: [
          "Die auf dieser Webseite veröffentlichten Inhalte, Werke und bereitgestellten Informationen unterliegen dem deutschen Urheberrecht und Leistungsschutzrecht. Jede Art der Vervielfältigung, Bearbeitung, Verbreitung, Einspeicherung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers. Das unerlaubte Kopieren/Speichern der bereitgestellten Informationen auf diesen Webseiten ist nicht gestattet und strafbar.",
        ],
      },
      {
        h: "4. Datenschutz",
        body: [
          "Durch den Besuch des Internetauftritts können Informationen (Datum, Uhrzeit, aufgerufene Seite) über den Zugriff auf dem Server gespeichert werden. Es werden keine personenbezogenen Daten (z. B. Name, Anschrift oder E-Mail-Adresse) gespeichert.",
          "Sofern personenbezogene Daten erhoben werden, erfolgt dies, sofern möglich, nur mit dem vorherigen Einverständnis des Nutzers der Webseite. Eine Weitergabe der Daten an Dritte findet ohne ausdrückliche Zustimmung des Nutzers nicht statt.",
          "Der Anbieter weist darauf hin, dass die Übertragung von Daten im Internet (z. B. per E-Mail) Sicherheitslücken aufweisen und ein lückenloser Schutz der Daten vor dem Zugriff Dritter nicht gewährleistet werden kann. Der Anbieter übernimmt keine Haftung für die durch solche Sicherheitslücken entstandenen Schäden.",
          "Der Verwendung der Kontaktdaten durch Dritte zur gewerblichen Nutzung wird ausdrücklich widersprochen, es sei denn, der Anbieter hat zuvor seine schriftliche Einwilligung erteilt. Der Anbieter behält sich rechtliche Schritte für den Fall der unverlangten Zusendung von Werbeinformationen, z. B. durch Spam-Mails, vor.",
        ],
      },
      {
        h: "5. Kontaktformular · Contact form",
        body: [
          "Bei Nutzung des Kontaktformulars werden Name, E-Mail-Adresse und Nachricht ausschließlich zur Bearbeitung Ihrer Anfrage gespeichert und verarbeitet. Eine Weitergabe an Dritte erfolgt nicht. Sie können die Löschung Ihrer Daten jederzeit per E-Mail verlangen.",
          "When using the contact form, your name, e-mail address and message are stored and processed solely to handle your enquiry. Data is never passed on to third parties. You may request deletion of your data at any time by e-mail.",
        ],
      },
    ],
  },
};

export const Legal = ({ kind }) => {
  const page = T[kind];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [kind]);

  return (
    <div className="min-h-screen bg-[#f9f6f0] pt-32 pb-24" data-testid={`legal-${kind}`}>
      <div className="max-w-3xl mx-auto px-6 sm:px-10">
        <Link
          to="/"
          className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-[#5c5656] hover:text-[#c86f53] transition-colors duration-300 mb-12"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={14} />
          Zurück · Back
        </Link>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight text-[#2a2626] font-medium mb-3" data-testid="legal-title">
          {page.title}
        </h1>
        <p className="font-display italic text-lg text-[#6b705c] font-light mb-14" data-testid="legal-note">
          {page.note}
        </p>
        <div className="space-y-10">
          {page.sections.map((s, i) => (
            <section key={i} className="border-t border-[#2a2626]/10 pt-8" data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-2xl text-[#2a2626] font-medium mb-4">{s.h}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="text-sm sm:text-base leading-relaxed text-[#5c5656] font-light mb-3 last:mb-0">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};
